import {Badge} from "@mantine/core";

// AssignmentStatus three-state (FNP-217): ACTIVE / PAUSED / CANCELED.
export const StatusBadge = ({status}: { status: string }) => {
    let color = 'blue';
    if (status === 'ACTIVE') {
        color = 'green';
    } else if (status === 'PAUSED') {
        color = 'yellow';
    } else if (status === 'CANCELED') {
        color = 'red';
    }
    return <Badge color={color}>{status}</Badge>;
};
